"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.alignSelf = exports.alignItems = exports.alignContent = void 0;
exports.alignContent = {
  patterns: {
    '*': '{{value}}'
  },
  properties: 'alignContent'
};
exports.alignItems = {
  patterns: {
    '*': '{{value}}'
  },
  properties: 'alignItems'
};
exports.alignSelf = {
  patterns: {
    '*': '{{value}}'
  },
  properties: 'alignSelf'
};